import { useEffect, useState } from 'react';
import { equipesApi } from '../../api/resources';
import { tr, trf } from '../../lib/i18n';
import { C } from '../../theme/palette';

/**
 * « Mon chef d'équipe » : dans une grosse société, l'employé sait qui dirige
 * son équipe. Ses messages vont au bureau ; son chef d'équipe et le patron les
 * lisent. Sans équipe, rien ne s'affiche.
 */
export function MonChefEquipe() {
  const [moi, setMoi] = useState(null);
  useEffect(() => {
    let vivant = true;
    Promise.resolve()
      .then(() => equipesApi.monChef())
      .then((r) => vivant && setMoi(r || null))
      .catch(() => {});
    return () => {
      vivant = false;
    };
  }, []);
  if (!moi?.chefNom) return null;
  const prenom = String(moi.chefNom).split(' ')[0];
  return (
    <div
      data-mon-chef
      style={{ display: 'flex', flexDirection: 'column', gap: 8, marginBottom: 12 }}
    >
      <div
        style={{
          background: C.white,
          border: '1px solid ' + C.border,
          borderRadius: 14,
          padding: 12,
          display: 'flex',
          gap: 10,
          alignItems: 'center',
        }}
      >
        <div
          aria-hidden="true"
          style={{
            width: 44,
            height: 44,
            borderRadius: 99,
            background: C.teal,
            color: C.white,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            fontWeight: 800,
            flexShrink: 0,
          }}
        >
          {prenom.charAt(0).toUpperCase()}
        </div>
        <div>
          <div style={{ fontSize: 12, color: C.grey }}>{tr("Mon chef d'équipe")}</div>
          <div style={{ fontSize: 15, fontWeight: 800, color: C.ink }}>{moi.chefNom}</div>
          {moi.equipe && <div style={{ fontSize: 11.5, color: C.grey }}>{moi.equipe}</div>}
        </div>
      </div>
      <div
        style={{
          fontSize: 12,
          color: C.ink,
          lineHeight: 1.5,
          background: C.tealL,
          padding: '10px 12px',
          borderRadius: 12,
        }}
      >
        {trf(
          'Tes messages, tes demandes de congé et de formation vont à {0} (ton chef) et au bureau. Le patron les voit aussi et peut toujours répondre.',
          prenom,
        )}
      </div>
    </div>
  );
}
